import { createAction } from '@reduxjs/toolkit';

import { TableItem } from '../types';

export type Sng = {
	id: number;
	minLevel: number;
	entryFee: number;
	users: string[];
	active_tables: number;
	registered_players: number;
	chips: any;
	registered?: boolean;
};

export const tournamentsListRequest = createAction('tournaments/listRequest');
export const tournamentsListRefreshRequest = createAction('tournaments/listRefreshRequest');
export const tournamentsSet = createAction<Sng[]>('tournaments/set');
export const tournamentsSubscribe = createAction('tournaments/subscribe');
export const tournamentsUnsubscribe = createAction('tournaments/unsubscribe');

export const tournamentsUpsert = createAction<Sng>('tournaments/upsert');

export const tournamentsClear = createAction('tournaments/clear');

export const tournamentsTableEnter = createAction<{ table: number | string }>(
	'tournaments/table/enter',
);

export const tournamentsTableLeave = createAction<{ table: number | string }>(
	'tournaments/table/leave',
);

export const tournamentsRegisterRequest = createAction<{
	tournamentId: string;
}>('tournaments/registerRequest');

export const tournamentsRegisterSuccess = createAction<{
	tournamentId: string;
	packet: any;
}>('tournaments/registerSuccess');

export const tournamentsRegisterFailure = createAction<{
	tournamentId: string;
	error: string;
}>('tournaments/registerFailure');
export const tournamentsRegisterErrorClear = createAction('tournaments/registerErrorClear');

export const tournamentsUnregisterRequest = createAction<{
	tournamentId: string;
}>('tournaments/unregisterRequest');

export const tournamentsUnregisterSuccess = createAction<{
	tournamentId: string;
	packet: any;
}>('tournaments/unregisterSuccess');

export const tournamentsUnregisterFailure = createAction<{
	tournamentId: string;
	error: string;
}>('tournaments/unregisterFailure');

export const tournamentsInviteOpen = createAction<{
	tournamentId: string;
	entryLevel: number;
}>('tournaments/inviteOpen');

export const tournamentsActiveRequest = createAction<{ roomId: string }>(
	'tournaments/active/request',
);

export const tournamentsActiveSuccess = createAction<{
	roomId: string;
	data: TableItem[];
}>('tournaments/active/success');

export const tournamentsActiveFailure = createAction<{
	roomId: string;
	error: string;
}>('tournaments/active/failure');
